import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import { AppLayout } from './components/layout/AppLayout';
import Dashboard from './pages/app/Dashboard';
import Profiles from './pages/app/Profiles';
import ProfileDetail from './pages/app/ProfileDetail';
import Assessments from './pages/app/Assessments';
import TakeAssessment from './pages/app/TakeAssessment';
import Results from './pages/app/Results';
import IEP from './pages/app/IEP';
import Admin from './pages/app/Admin';
import Reports from './pages/app/Reports';
import Settings from './pages/app/Settings';
import PatientAnalysis from './pages/patient/PatientAnalysis';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider, useData } from './contexts/DataContext';
import { useAuth } from './contexts/AuthContext';
import PatientLayout from './components/layout/PatientLayout';
import PatientDashboard from './pages/patient/PatientDashboard';
import PatientAssessmentFlow from './pages/patient/PatientAssessmentFlow';

// Protected Route Component
const ProtectedRoute = ({ children, allowedRole }) => {
  const { user } = useAuth();
  if (!user) {
    window.location.href = '/login';
    return null;
  }
  if (allowedRole && user.role !== allowedRole && !(allowedRole === 'Therapist' && user.role === 'Admin')) {
    return <Navigate to={user.role === 'Patient' ? '/Screening_test/patient' : '/Screening_test/app'} replace />;
  }
  return children;
};

const RootRedirect = () => {
  const { user } = useAuth();
  if (!user) {
    window.location.href = '/login';
    return null;
  }
  return <Navigate to={user.role === 'Patient' ? '/Screening_test/patient' : '/Screening_test/app'} replace />;
};

function App() {
  return (
      <AuthProvider>
        <DataProvider>
          <div className="min-h-screen font-sans text-slate-900 bg-slate-50">
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="login" element={<Login />} />
              <Route path="register" element={<Register />} />

              <Route path="app" element={<ProtectedRoute allowedRole="Therapist"><AppLayout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="profiles" element={<Profiles />} />
                <Route path="profiles/:id" element={<ProfileDetail />} />
                <Route path="assessments" element={<Assessments />} />
                <Route path="assessments/take" element={<TakeAssessment />} />
                <Route path="assessments/analysis/:id" element={<PatientAnalysis />} />
                <Route path="results" element={<Results />} />
                <Route path="iep" element={<IEP />} />
                <Route path="admin" element={<Admin />} />
                <Route path="reports" element={<Reports />} />
                <Route path="settings" element={<Settings />} />
              </Route>

              <Route path="patient" element={<ProtectedRoute allowedRole="Patient"><PatientLayout /></ProtectedRoute>}>
                <Route index element={<PatientDashboard />} />
                <Route path="assessment" element={<PatientAssessmentFlow />} />
                <Route path="analysis" element={<PatientAnalysis />} />
              </Route>
            </Routes>
          </div>
        </DataProvider>
      </AuthProvider>
  );
}

export default App;
